import * as React from 'react';
import { HelpBlock } from 'react-bootstrap';

const FieldFormError = ({
                          placeholder,
                          type,
                          input,
                          componentClass,
                          className,
                          style,
                          meta,
                          complexValue = false,
                          cleaveOptions = null,
                          omitError = false,
                          ...props
                        }) => {

  return (
    <div className={meta.touched && meta.error ? 'field-form-error' : ''}>
      {!omitError && meta.touched && meta.error && (<HelpBlock>{meta.error}</HelpBlock>)}
    </div>
  );
};

export default FieldFormError;
